import { createProcessingSelector } from 'store/loading/selectors';
import { GET_APP_ACCESS_CODE } from 'store/auth/actionTypes';

import { useSelector } from 'hooks';

import CopyCodeMobile from './components/CopyCodeMobile';
import CopyCodeDesktop from './components/CopyCodeDesktop';

const CopyCodeStep = ({ isMobileDevice, access_code }: { isMobileDevice: boolean; access_code?: string }) => {
    const isLoading = useSelector(createProcessingSelector([GET_APP_ACCESS_CODE]));

    if (isMobileDevice) return <CopyCodeMobile accessCode={access_code} isLoading={isLoading} />;

    return <CopyCodeDesktop accessCode={access_code} isLoading={isLoading} />;
};

export default CopyCodeStep;
